import { LeverageDirection, TradeType } from "@gql/offer";
import { Fiat } from "@models";
import { Tradable as LegacyTradeable } from "@models/interfaces/tradable";
import { Tradable } from "@modules/+new/core/tradables/domain/entities/tradable";
import { IAmountSelectionProperties, IFiatDepositInfo } from "@modules/checkout/entities/checkout.amount.model";
import { CurrencyOverrideType, PriceConversions } from "@modules/checkout/entities/checkout.model";
import { CashPlusPortfolioApi } from "@modules/cashplus/entities/cashplus.model";

export enum MarginTradingRouteName {
	MarginTradingIntro = "margin-trading-intro",
	MarginTradingCurrenySelection = "margin-trading-currency-selection",
	MarginTradingBuyAmount = "margin-trading-amount",
	MarginTradingAppropriateness = "margin-trading-appropriateness",
	MarginTradingBuySummary = "margin-trading-summary",
	MarginTradingSellAmount = "margin-trading-sell-amount",
	MarginTradingSellSummary = "margin-trading-sell-summary",
	MarginTradingSuccess = "margin-trading-success",
	MarginTradingPositionDetail = "margin-trading-position-detail",
	MarginLimitOrderSellAmount = "margin-sell-limit-order-amount",
	MarginLimitOrderReview = "margin-limit-order-review",
	MarginLimitOrderSuccess = "margin-limit-order-success",
	MarginTradingV2Appropriateness = "margin-trading-appropriateness-v2"
}

export interface MarginTradingBuyViewModel {
	amountViewModel: Partial<IAmountSelectionProperties>;
	tradable: Tradable;
	legacyTradable: LegacyTradeable;
	priceConversions: PriceConversions;
	fiat: Fiat;
	isWireTransfer: boolean;
	fiatDepositInfo: IFiatDepositInfo;
	isFiatSelected: boolean;
	amount?: number;
	fiatBalance: number;
	stableCoin: LegacyTradeable;
	stableCoinBalance: string;
	currencyOverride: CurrencyOverrideType;
	fiatWalletId: string;
	cashPlusInfo?: CashPlusPortfolioApi;
}

export interface MarginTradingSellViewModel {
	amountViewModel: Partial<IAmountSelectionProperties>;
	availableFiat: number;
	availableAsset: number;
	availableAssetString: string;
	tradable: Tradable;
	legacyTradable: LegacyTradeable;
	priceConversions: PriceConversions;
	fiat: Fiat;
	isFiatSelected: boolean;
	amount: number;
	fiatBalance: number;
	stableCoin: LegacyTradeable;
	stableCoinBalance: string;
	currencyOverride: CurrencyOverrideType;
	fiatWalletId: string;
}

export interface IfetchMarginEstimationRequest {
	amountViewModel: Partial<IAmountSelectionProperties>;
	amount: number;
	tradeType: TradeType;
	leverageDirection: LeverageDirection;
	leverage?: number;
	currencyOverride?: CurrencyOverrideType;
}

interface MarginTradingAnswers {
	answer: string;
	label: string;
	sort: number;
	valid: boolean;
	id: string;
}

export interface MarginTradingQuestions {
	answers: MarginTradingAnswers[];
	label: string;
	question: string;
	sort: number;
	type: string;
	id: string;
}

export interface MarginTradingQuestionsModel {
	questions: MarginTradingQuestions[];
	label: string;
	id: string;
}

export interface NewMarginTradingQuestionsModel {
	questions: NewMarginTradingQuestions[];
	id?: string;
}

export interface NewMarginTradingQuestions {
	answers: NewMarginTradingAnswers[];
	description: string;
	question: string;
	type: string;
	id: string;
	input_placeholder?: string;
}

interface NewMarginTradingAnswers {
	answer: string;
	id: string;
	valid?: boolean;
}

export interface QuestionnaireModel {
	questionnaire: MarginTradingQuestionsModel | NewMarginTradingQuestionsModel;
	isLoadingSubmission: boolean;
	isLoading: boolean;
	isError: boolean;
}

export interface NewQuestionnaireModel {
	questionnaire: NewMarginTradingQuestionsModel;
	isLoadingSubmission: boolean;
	isLoading: boolean;
	isError: boolean;
}

export interface MarginTradingPostAnswers {
	question_id: string;
	answers: string[];
}

export interface MarginTradingAnswersV2 {
	answer_id: string;
	answer_value?: null;
	question_id: string;
}

export interface v2AnswerSubmitResponse {
	status: string;
	cool_off_end: string;
	correct_answers: string;
	total_questions: string;
}
